<script setup lang="ts">
import { Components } from '@/api/generated/api';
import CustomButton from '@/core/elements/CustomButton.vue';
import EmptyPlaceholder from '@/core/elements/EmptyPlaceholder.vue';

const emit = defineEmits<{
  'click:create-competences': [];
}>();

defineProps<{
  availableSchoolSubjects: Components.Schemas.SchoolSubjectDto[];
}>();
</script>

<template>
  <div class="flex items-center justify-center h-full grid-rows-[auto_1fr] px-content">
    <div class="flex flex-col gap-md">
      <EmptyPlaceholder :data="availableSchoolSubjects" :message="$t('schoolSubjects.noSubjects')" />
      <CustomButton theme="link" class="self-center" @click="emit('click:create-competences')">
        {{ $t('classes.createCompetences') }}
      </CustomButton>
    </div>
  </div>
</template>
